(function (global) {
  'use strict';

  if (global.SamTagImageCache) return;

  var STORAGE_KEY = 'samTagImageCache:v1';

  function normalizeImagesRecord(value) {
    if (typeof value === 'string') {
      var src = String(value || '').trim();
      return {
        front: src,
        back: '',
        designData: '',
      };
    }

    if (!value || typeof value !== 'object') {
      return {
        front: '',
        back: '',
        designData: '',
      };
    }

    return {
      front: String(value.front || '').trim(),
      back: String(value.back || '').trim(),
      designData: String(value.designData || '').trim(),
    };
  }

  function readCache() {
    try {
      var raw = global.localStorage ? global.localStorage.getItem(STORAGE_KEY) : '';
      if (!raw) return {};
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (err) {
      return {};
    }
  }

  function writeCache(cache) {
    if (!global.localStorage) return;
    try {
      global.localStorage.setItem(STORAGE_KEY, JSON.stringify(cache || {}));
    } catch (err) {
      // Ignore localStorage quota and privacy errors.
    }
  }

  function getItemImage(key) {
    var normalizedKey = String(key || '').trim();
    if (!normalizedKey) return '';
    var cache = readCache();
    return normalizeImagesRecord(cache[normalizedKey]).front;
  }

  function getItemImages(key) {
    var normalizedKey = String(key || '').trim();
    if (!normalizedKey) return normalizeImagesRecord(null);
    var cache = readCache();
    return normalizeImagesRecord(cache[normalizedKey]);
  }

  function setItemImage(key, imageSrc) {
    setItemImageForSide(key, 'front', imageSrc);
  }

  function setItemImageForSide(key, side, imageSrc) {
    var normalizedKey = String(key || '').trim();
    var normalizedSide = side === 'back' ? 'back' : 'front';
    var normalizedSrc = String(imageSrc || '').trim();
    if (!normalizedKey || !normalizedSrc) return;

    var cache = readCache();
    var record = normalizeImagesRecord(cache[normalizedKey]);
    record[normalizedSide] = normalizedSrc;
    cache[normalizedKey] = record;
    writeCache(cache);
  }

  function setItemImages(key, images) {
    var normalizedKey = String(key || '').trim();
    if (!normalizedKey) return;

    var cache = readCache();
    var existingRecord = normalizeImagesRecord(cache[normalizedKey]);
    var record = normalizeImagesRecord(images);
    if (!record.designData && existingRecord.designData) {
      record.designData = existingRecord.designData;
    }
    if (!record.front && !record.back) return;

    cache[normalizedKey] = record;
    writeCache(cache);
  }

  function getItemDesignData(key) {
    var normalizedKey = String(key || '').trim();
    if (!normalizedKey) return '';
    var cache = readCache();
    return normalizeImagesRecord(cache[normalizedKey]).designData;
  }

  function setItemDesignData(key, designData) {
    var normalizedKey = String(key || '').trim();
    var normalizedDesignData = String(designData || '').trim();
    if (!normalizedKey || !normalizedDesignData) return;

    var cache = readCache();
    var record = normalizeImagesRecord(cache[normalizedKey]);
    record.designData = normalizedDesignData;
    cache[normalizedKey] = record;
    writeCache(cache);
  }

  function removeItemImage(key) {
    var normalizedKey = String(key || '').trim();
    if (!normalizedKey) return;

    var cache = readCache();
    if (!(normalizedKey in cache)) return;
    delete cache[normalizedKey];
    writeCache(cache);
  }

  global.SamTagImageCache = {
    getItemImage: getItemImage,
    getItemImages: getItemImages,
    setItemImage: setItemImage,
    setItemImageForSide: setItemImageForSide,
    setItemImages: setItemImages,
    getItemDesignData: getItemDesignData,
    setItemDesignData: setItemDesignData,
    removeItemImage: removeItemImage,
    readCache: readCache,
  };
})(window);
